/**
 * config.js — Central URL/endpoint configuration for TEC_APP (localhost:3000)
 *
 * Production URLs are hardcoded below.
 * To switch back to local development, uncomment the LOCAL block
 * and comment out the PRODUCTION block.
 */

/* ── LOCAL DEVELOPMENT (comment out when deploying) ──────────────────────────
export const API_URLS = {
  weatherApp:       process.env.REACT_APP_WEATHER_URL || 'http://localhost:3001',
  spaceApp:         process.env.REACT_APP_SPACE_URL   || 'http://localhost:3002',
  mlBackend:        process.env.REACT_APP_ML_API      || 'http://localhost:8000',
  weatherDisasters: (process.env.REACT_APP_WEATHER_URL || 'http://localhost:3001') + '/disasters/predictions?type=weather',
  spaceDisasters:   (process.env.REACT_APP_SPACE_URL   || 'http://localhost:3002') + '/disasters/predictions?type=space',
  spaceWeatherNow:  (process.env.REACT_APP_ML_API || 'http://localhost:8000') + '/spaceweather/now',
  spaceWeatherAll:  (process.env.REACT_APP_ML_API || 'http://localhost:8000') + '/spaceweather/all',
};
── END LOCAL ───────────────────────────────────────────────────────────────── */

/* ── PRODUCTION (comment out when developing locally) ────────────────────── */
const WEATHER = 'https://weather.busitemaspacescience.com';
const SPACE   = 'https://space.busitemaspacescience.com';
const API     = 'https://api.busitemaspacescience.com';
const BASE = "https://tecapi.busitemaspacescience.com";

export const API_URLS = {
  weatherApp:       WEATHER,
  spaceApp:         SPACE,
  mlBackend:        API,
  weatherDisasters: `${BASE}/weather/latest`,
  spaceDisasters:   `${BASE}/spaceweather/latest`,
  spaceWeatherNow:  `${BASE}/spaceweather/now`,
  spaceWeatherAll:  `${BASE}/spaceweather/all`,
  health:           `${BASE}/spaceweather/now`,
  weatherNow:       `${BASE}/weather/now`,
};
/* ── END PRODUCTION ─────────────────────────────────────────────────────── */
